/* eslint-disable react/prop-types */
import React from "react";
import { Link, useParams } from "react-router-dom";
import { useDemoScrollToTop } from "../../hooks/useDemoScrollToTop";
import {
  Alert,
  Breadcrumb,
  Button,
  Divider,
  Empty,
  Layout,
  Typography,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import statusColor from "../../components/utils/satus";
import Platform from "../../components/platforms";
import DemoLayout from "./DemoLayout";
import DemoMetricCharts from "./DemoMetricCharts";
import { getDemoLiveProjectPage } from "./dummyData";

const { Content } = Layout;
const { Title } = Typography;

/**
 * Sample project detail for live demo titles only — static data, no API or auth.
 */
const DemoProjectPage = () => {
  const { id } = useParams();
  const detail = getDemoLiveProjectPage(id);

  useDemoScrollToTop([id]);

  if (!detail) {
    return (
      <DemoLayout backLink={{ to: "/demo", label: "← Demo dashboard" }}>
        <div
          style={{ maxWidth: 720, margin: "48px auto", textAlign: "center" }}
        >
          <Empty
            description="This sample project is not available."
            style={{ marginBottom: 24 }}
          />
          <Link to="/demo">
            <Button type="primary">Back to sample dashboard</Button>
          </Link>
        </div>
      </DemoLayout>
    );
  }

  const { project, distribution, chart } = detail;
  const st = statusColor[project.distributionStatus || "inactive"];

  return (
    <DemoLayout backLink={{ to: "/demo", label: "← Demo dashboard" }}>
      <div style={{ maxWidth: 960, margin: "0 auto" }}>
        <Alert
          showIcon
          type="info"
          message="Sample project"
          description="Figures and platform names are fictional. Sign in to SHORTED to view your real project and analytics."
          style={{ marginTop: 24, marginBottom: 16 }}
        />
        <Content
          className="site-layout-background vc-panel"
          style={{ padding: 24 }}
        >
          <Breadcrumb separator="/">
            <Breadcrumb.Item>
              <Link to="/demo">Sample dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{project.title}</Breadcrumb.Item>
          </Breadcrumb>
          <Divider />
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <Link to="/demo">
              <ArrowLeftOutlined style={{ fontSize: 20, marginRight: 16 }} />
            </Link>
            <Title level={2} style={{ margin: 0 }}>
              {project.title}
            </Title>
          </div>
          <Divider />
          <div
            style={{
              position: "relative",
              width: "100%",
              aspectRatio: "16 / 9",
              borderRadius: 8,
              overflow: "hidden",
              marginBottom: 16,
              background: "var(--vc-border)",
            }}
          >
            <img
              alt=""
              src={project.photo_url}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
          <Alert
            message={st.title}
            description={st.description}
            type={st.type}
            showIcon
            style={{ marginBottom: 24 }}
          />
          <Platform distribution={distribution} />
          <DemoMetricCharts chart={chart} />
        </Content>
        <div style={{ marginTop: 24, textAlign: "center" }}>
          <Link to={{ pathname: "/", hash: "login" }}>
            <Button type="primary" size="large">
              Sign in for your real project view
            </Button>
          </Link>
        </div>
      </div>
    </DemoLayout>
  );
};

export default DemoProjectPage;
